import React, {Component, PropTypes} from 'react';
import {CAMERA_SNAPSHOT_INTERVAL} from '../constants/defaultValues';

class CameraSnapshot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: undefined,
      intervalId: 0,
      random: ''
    };
  }

  componentDidMount() {
    if (this.props.target) {
      const url = this.props.target
      const intervalId = setInterval(this._refresh.bind(this), CAMERA_SNAPSHOT_INTERVAL);
      this.setState({url: url, intervalId: intervalId});
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  _refresh() {
    const random = Math.random().toString(36).substring(7);
    const url = this.state.url
    const link = (url && url.indexOf("/") > -1)
      ? url.substring(0, url.lastIndexOf("/") + 1)
      : url

    this.setState({
      url: link + random,
      random: random
    });
  }

  render() {
    const url = this.state.url;
    return <img src={url} height="100%" width="100%"/>
  }
}

export default CameraSnapshot;



// WEBPACK FOOTER //
// ./src/components/CameraSnapshot.js